
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vende-tu-moto",
      function () {
        return require("private-next-pages/vende-tu-moto.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vende-tu-moto"])
      });
    }
  